import {
    SEND_TEXT, SEND_TEXT_RESET,
    LOGIN, LOGIN_RESET,
    GET_TOKEN, GET_TOKEN_RESET,
    LOGIN_STEP_1_CONFIRMATION_CODE, LOGIN_STEP_1_CONFIRMATION_CODE_RESET,
    GET_IDP_AUTHENTICATION_URL, GET_IDP_AUTHENTICATION_URL_RESET,
    IDP_LOGIN, IDP_LOGIN_RESET,
    GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN, GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET,
    RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN, RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET,
    CONFIRM_SOCIAL_LOGIN_ACCOUNT, CONFIRM_SOCIAL_LOGIN_ACCOUNT_RESET,
    GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN, GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN_RESET,
    CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS, CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS_RESET,
    SEND_CONFIRMATION_CODE, SEND_CONFIRMATION_CODE_RESET, GET_USER_IDP_ACCOUNTS_RESET, GET_USER_IDP_ACCOUNTS, LINK_USER_IDP_ACCOUNT, LINK_USER_IDP_ACCOUNT_RESET, DELETE_USER_IDP_ACCOUNT, DELETE_USER_IDP_ACCOUNT_RESET
} from '../actions/security';

const initialState = {
    sendTextSuccess: null,
    sendTextError: null,
    loginSuccess: null,
    loginError: null,
    accountId: null,
    refreshToken: null,
    accessToken: null,
    getTokenSuccess: null,
    getTokenError: null,
    token: null,
    loginStep1ConfirmationCodeSuccess: null,
    loginStep1ConfirmationCodeError: null,
    loginStep1ConfirmationCodeRedirect: null,
    getIdpAuthenticationUrlSuccess: null,
    getIdpAuthenticationUrlError: null,
    getIdpAuthenticationUrlUrl: null,
    idpLoginError: null,
    idpLoginSuccess: null,
    getConfirmationCodeForAccountExistsSocialLoginSuccess: null,
    getConfirmationCodeForAccountExistsSocialLoginError: null,
    resendConfirmationCodeForSocialLoginSuccess: null,
    resendConfirmationCodeForSocialLoginError: null,
    getConfirmationCodeForSocialLoginSuccess: null,
    getConfirmationCodeForSocialLoginError: null,
    getConfirmationCodeForSocialLoginErrorStatus: null,
    idpLoginErrorResponse: null,
    confirmSocialLoginAccountSuccess: null,
    confirmSocialLoginAccountError: null,
    confirmSocialLoginAccountAccountExistsSuccess: null,
    confirmSocialLoginAccountAccountExistsError: null,
    sendConfirmationCodeSuccess: null,
    sendConfirmationCodeERROR: null,
    sendConfirmationCodeUsername: '',
    userIdpAccounts: [],
    getUserIdpAccountsSuccess: null,
    getUserIdpAccountsError: null,
    linkUserIdpAccountSuccess: null,
    linkUserIdpAccountError: null,
    linkUserIdpAccountErrorResponse: null,
    deleteUserIdpAccountSuccess: null,
    deleteUserIdpAccountError: null,
    idpLoginErrorIdpService: null,
    confirmSocialLoginAccountErrorResponse: null
};


export default function securityReducer(state = initialState, action) {
    switch (action.type) {
        case LINK_USER_IDP_ACCOUNT:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    linkUserIdpAccountSuccess: true,
                }),
                ...(action.error && {
                    linkUserIdpAccountErrorResponse: action.payload
                }),
                linkUserIdpAccountError: action.error
            };
        case LINK_USER_IDP_ACCOUNT_RESET:
            return {
                ...state,
                linkUserIdpAccountSuccess: initialState.linkUserIdpAccountSuccess,
                linkUserIdpAccountError: initialState.linkUserIdpAccountError,
                linkUserIdpAccountErrorResponse: initialState.linkUserIdpAccountErrorResponse
            };
        case DELETE_USER_IDP_ACCOUNT:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    deleteUserIdpAccountSuccess: true,
                }),
                deleteUserIdpAccountError: action.error
            };
        case DELETE_USER_IDP_ACCOUNT_RESET:
            return {
                ...state,
                deleteUserIdpAccountSuccess: initialState.deleteUserIdpAccountSuccess,
                deleteUserIdpAccountError: initialState.deleteUserIdpAccountError,
            };
        case GET_USER_IDP_ACCOUNTS:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    getUserIdpAccountsSuccess: true,
                    userIdpAccounts: action.payload.userIdpAccounts
                }),
                getUserIdpAccountsError: action.error
            };
        case GET_USER_IDP_ACCOUNTS_RESET:
            return {
                ...state,
                getUserIdpAccountsSuccess: initialState.getUserIdpAccountsSuccess,
                getUserIdpAccountsError: initialState.getUserIdpAccountsError,
            };
        case CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    confirmSocialLoginAccountAccountExistsSuccess: true,
                }),
                confirmSocialLoginAccountAccountExistsError: action.error
            };
        case CONFIRM_SOCIAL_LOGIN_ACCOUNT_ACCOUNT_EXISTS_RESET:
            return {
                ...state,
                confirmSocialLoginAccountAccountExistsSuccess: initialState.confirmSocialLoginAccountAccountExistsSuccess,
                confirmSocialLoginAccountAccountExistsError: initialState.confirmSocialLoginAccountAccountExistsError,
            };
        case CONFIRM_SOCIAL_LOGIN_ACCOUNT:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    confirmSocialLoginAccountSuccess: true,
                }),
                ...(action.error && {
                    confirmSocialLoginAccountErrorResponse: action.payload
                }),
                confirmSocialLoginAccountError: action.error
            };
        case CONFIRM_SOCIAL_LOGIN_ACCOUNT_RESET:
            return {
                ...state,
                confirmSocialLoginAccountSuccess: initialState.confirmSocialLoginAccountSuccess,
                confirmSocialLoginAccountError: initialState.confirmSocialLoginAccountError,
                confirmSocialLoginAccountErrorResponse: initialState.confirmSocialLoginAccountErrorResponse
            };
        case GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    getConfirmationCodeForAccountExistsSocialLoginSuccess: true,
                }),
                getConfirmationCodeForAccountExistsSocialLoginError: action.error
            };
        case GET_CONFIRMATION_CODE_FOR_ACCOUNT_EXISTS_SOCIAL_LOGIN_RESET:
            return {
                ...state,
                getConfirmationCodeForAccountExistsSocialLoginSuccess: initialState.getConfirmationCodeForAccountExistsSocialLoginSuccess,
                getConfirmationCodeForAccountExistsSocialLoginError: initialState.getConfirmationCodeForAccountExistsSocialLoginError,
            };
        case GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    getConfirmationCodeForSocialLoginSuccess: true,
                }),
                ...(action.payload && action.error && {
                    getConfirmationCodeForSocialLoginErrorStatus: action.payload.response.status
                }),
                getConfirmationCodeForSocialLoginError: action.error
            };
        case GET_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET:
            return {
                ...state,
                getConfirmationCodeForSocialLoginSuccess: initialState.getConfirmationCodeForSocialLoginSuccess,
                getConfirmationCodeForSocialLoginError: initialState.getConfirmationCodeForSocialLoginError,
                getConfirmationCodeForSocialLoginErrorStatus: initialState.getConfirmationCodeForSocialLoginErrorStatus
            };
        case RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    resendConfirmationCodeForSocialLoginSuccess: true,
                }),
                resendConfirmationCodeForSocialLoginError: action.error
            };
        case RESEND_CONFIRMATION_CODE_FOR_SOCIAL_LOGIN_RESET:
            return {
                ...state,
                resendConfirmationCodeForSocialLoginSuccess: initialState.resendConfirmationCodeForSocialLoginSuccess,
                resendConfirmationCodeForSocialLoginError: initialState.resendConfirmationCodeForSocialLoginError,
            };
        case IDP_LOGIN:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    idpLoginSuccess: true,
                }),
                ...(action.payload && action.error && {
                    idpLoginErrorResponse: action.payload.response,
                    idpLoginErrorIdpService: action.meta.idpService
                }),
                idpLoginError: action.error
            };
        case IDP_LOGIN_RESET:
            return {
                ...state,
                idpLoginSuccess: initialState.idpLoginSuccess,
                idpLoginError: initialState.idpLoginError,
                idpLoginErrorResponse: initialState.idpLoginErrorResponse,
                idpLoginErrorIdpService: initialState.idpLoginErrorIdpService
            };
        case GET_IDP_AUTHENTICATION_URL:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    getIdpAuthenticationUrlSuccess: true,
                    getIdpAuthenticationUrlUrl: action.payload.getIdpAuthenticationUrlUrl
                }),
                getIdpAuthenticationUrlError: action.error
            };
        case GET_IDP_AUTHENTICATION_URL_RESET:
            return {
                ...state,
                getIdpAuthenticationUrlUrl: initialState.getIdpAuthenticationUrlUrl,
                getIdpAuthenticationUrlSuccess: initialState.getIdpAuthenticationUrlSuccess,
                getIdpAuthenticationUrlError: initialState.getIdpAuthenticationUrlError,
            };
        case SEND_CONFIRMATION_CODE:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    sendConfirmationCodeSuccess: true,
                    sendConfirmationCodeUsername: action.payload.username
                }),
                sendConfirmationCodeError: action.error
            };
        case SEND_CONFIRMATION_CODE_RESET:
            return {
                ...state,
                sendConfirmationCodeSuccess: initialState.sendConfirmationCodeSuccess,
                sendConfirmationCodeError: initialState.sendConfirmationCodeError,
                sendConfirmationCodeUsername: initialState.sendConfirmationCodeUsername
            };
        case LOGIN_STEP_1_CONFIRMATION_CODE:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    loginStep1ConfirmationCodeSuccess: true,
                    loginStep1ConfirmationCodeRedirect: action.payload.redirect
                }),
                loginStep1ConfirmationCodeError: action.error
            };
        case LOGIN_STEP_1_CONFIRMATION_CODE_RESET:
            return {
                ...state,
                loginStep1ConfirmationCodeSuccess: initialState.loginStep1ConfirmationCodeSuccess,
                loginStep1ConfirmationCodeError: initialState.loginStep1ConfirmationCodeError,
                loginStep1ConfirmationCodeRedirect: initialState.loginStep1ConfirmationCodeRedirect
            };
        case GET_TOKEN:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    getTokenSuccess: true,
                    token: action.payload.token
                }),
                getTokenError: action.error
            };
        case GET_TOKEN_RESET:
            return {
                ...state,
                getTokenSuccess: initialState.getTokenSuccess,
                getTokenError: initialState.getTokenError,
            };
        case SEND_TEXT:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {sendTextSuccess: true}),
                sendTextError: action.error
            };
        case SEND_TEXT_RESET:
            return {
                ...state,
                sendTextSuccess: initialState.sendTextSuccess,
                sendTextError: initialState.sendTextError,
            };
        case LOGIN:
            return {
                ...state,
                ...(action.payload && action.meta && action.meta.sent && {
                    loginSuccess: true,
                    accessToken: action.payload.accessToken,
                    refreshToken: action.payload.refreshToken,
                    accountId: action.payload.accountId
                }),
                loginError: action.error
            };
        case LOGIN_RESET:
            return {
                ...state,
                loginSuccess: initialState.loginSuccess,
                loginError: initialState.loginError,
            };
        default:
            return state;
    }
}